module.exports = __webpack_public_path__ + "static/media/wizualizacja-21.14a12960.png";